import { render, staticRenderFns } from "./NotificationPost.vue?vue&type=template&id=2b61281e&scoped=true&"
import script from "./NotificationPost.vue?vue&type=script&lang=js&"
export * from "./NotificationPost.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPost.vue?vue&type=style&index=0&id=2b61281e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b61281e",
  null
  
)

export default component.exports